import { Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({ name: 'bytes' })
export class BytesPipe implements PipeTransform {
  private UNITS: Record<string, string[]> = {
    bytes: [
      this.translate.instant('bytes'),
      this.translate.instant('KB'),
      this.translate.instant('MB'),
      this.translate.instant('GB'),
      this.translate.instant('TB'),
      this.translate.instant('PB'),
      this.translate.instant('EB'),
      this.translate.instant('ZB'),
      this.translate.instant('YB'),
    ],
    bytesShort: [],
    items: [
      '',
      this.translate.instant('K'),
      this.translate.instant('M'),
      this.translate.instant('B'),
      this.translate.instant('T'),
    ],
  }

  constructor (private translate: TranslateService) {
    this.UNITS.bytesShort = [this.translate.instant('B'), ...this.UNITS.bytes.slice(1)]
  }

  transform (value: number|string, precision?: number, unitSet?: string): string {
    unitSet ??= 'bytes'
    if (typeof value === 'string') {
      value = parseFloat(value)
    }
    if (isNaN(value) || !isFinite(value)) {
      return '-'
    }
    const units = this.UNITS[unitSet]
    if (value === 0) {
      return `0 ${units[0]}`
    }
    precision ??= 1
    let power = Math.max(0, Math.floor(Math.log(value / 10) / Math.log(1000)))
    power = Math.min(power, units.length - 1)
    return (value / Math.pow(1000, Math.floor(power))).toFixed(precision) + ' ' + units[power]
  }
}
